import { render, staticRenderFns } from "./MarketplaceFieldForm.vue?vue&type=template&id=5af192e3&"
import script from "./MarketplaceFieldForm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceFieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports